import "./base.css";
import React from "react";
import { createRoot } from "react-dom/client";
import OneSignal from "react-onesignal";
import App from "./app.tsx";
import env from "./env.config.ts";

const root = document.getElementById("root");

OneSignal.init({
	appId: env.oneSignalAppId,
	safari_web_id: env.oneSignalSafariId,
	autoResubscribe: true,
	notifyButton: {
		enable: false,
	},
	welcomeNotification: {
		title: "HEMI Teams",
		message: "Thanks for subscribing!",
	},
	path: "/dashboard/",
	serviceWorkerParam: { scope: "/dashboard/" },
	serviceWorkerPath: "OneSignalSDKWorker.js",
	serviceWorkerUpdaterPath: "OneSignalSDKUpdaterWorker.js",
	notificationClickHandlerMatch: "origin",
	notificationClickHandlerAction: "focus",
});

if (root && !root?.innerHTML) {
	createRoot(root).render(
		<React.StrictMode>
			<App />
		</React.StrictMode>,
	);
}
